"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _CommentBody = _interopRequireDefault(require("../../components/Comment/components/CommentBody")),
    _CommentFooter = _interopRequireDefault(require("../../components/Comment/components/CommentFooter")),
    _utils = require("../../utils");

require("./_replies.scss");

var INITIAL_REPLIES_COUNT = 2;

function Replies(a) {
  var b = a.replies,
      c = a.handleDelete,
      d = a.deleteComment,
      e = (0, _react.useState)(!1),
      f = (0, _slicedToArray2["default"])(e, 2),
      g = f[0],
      h = f[1];
  if (!b.length) return null;
  var i = g ? b : b.slice(b.length - INITIAL_REPLIES_COUNT, b.length),
      j = b.length - INITIAL_REPLIES_COUNT;
  return _react["default"].createElement("div", {
    className: "comment-replies"
  }, 2 < b.length ? _react["default"].createElement(_uiKit.Link, {
    button: !0,
    onClick: function onClick() {
      return h(!g);
    },
    className: "comment-replies__toggle-more-replies"
  }, g ? "Hide older replies" : "Show ".concat(j, " more ").concat(1 === j ? "reply" : "replies")) : null, i.map(function (a) {
    return _react["default"].createElement("div", {
      className: "comment-replies__reply"
    }, _react["default"].createElement(_CommentBody["default"], {
      small: !0,
      content: a.content
    }), _react["default"].createElement(_CommentFooter["default"], {
      user: (0, _utils.getUser)(a.createdByUser),
      handleDelete: c && c({
        commentId: a.commentId,
        deleteComment: d
      }),
      updatedAt: a.updatedAt
    }));
  }));
}

var _default = (0, _react.memo)(Replies);

exports["default"] = _default;